module.exports = __webpack_public_path__ + "arrow.png?36d22ebfb5de6e14fcfcaa1e3188ff53";